// angular
// 	.module("HeroPRO")
// 	.controller("ApplicationResultsController", ApplicationResultsController);

import './applicationResults.scss';

/* @ngInject */
export default function ApplicationResultsController(FRInformationFactory, HPStateMachineConfig, HPConfig) {
    const vm = this;
    vm.appInfo = {};
    vm.applicationStatus = '';
    vm.isConditionallyApproved = false;    
    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    /* -----  End of Public Functions  ------*/


    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        vm.isDevelopment = (HPConfig.environment == 'DEV');
        FRInformationFactory.getFundingRequestInformationPromise().then(() => {
            vm.appInfo = FRInformationFactory.getAppInfo();
            let stateMachineData = FRInformationFactory.getStateMachineData();
            vm.isConditionallyApproved = stateMachineData.LoanStateId === HPStateMachineConfig.Loan.AUS_Conditionally_Approved;
            updateStatus();
        });
    }

    function updateStatus() {
        switch (vm.appInfo.ApplicationStatus) {
        case 'Cancelled':
            vm.applicationStatus = 'Approved';
            break;
        case 'Final - Canceled 1':
        case 'Final - Canceled 2':
        case 'Final - Canceled 3':
            vm.applicationStatus = 'Approved';
            break;
        case 'Final - Denied':
            vm.applicationStatus = 'Denied';
            break;
        case 'Final - Funded':
            vm.applicationStatus = 'Denied';
            break;
        default:
            vm.applicationStatus = vm.appInfo.ApplicationStatus;
            break;
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/application/applicationResultsController.js